// Langue de référence : ses clés définissent le type de toutes les autres
// (cf. src/i18n/index.ts). Un namespace par zone de l'app.
import common from "./common.json";
import type { ErrorCode } from "@/../convex/config/errorsConfig";
import serverErrors from "@/../convex/config/errorsConfig";
import shell from "./shell.json";
import settings from "./settings.json";
import canvas from "./canvas.json";
import nole from "./nole.json";
import windows from "./windows.json";
import nodes from "./nodes.json";
import table from "./table.json";
import editor from "./editor.json";
import core from "./core.json";

// Les messages d'erreur anglais sont ceux du serveur : une seule source.
const errors: Record<ErrorCode, string> = serverErrors;

const en = {
  common,
  errors,
  shell,
  settings,
  canvas,
  nole,
  windows,
  nodes,
  table,
  editor,
  core,
};

export default en;
